module.exports = __webpack_public_path__ + "assets/img/v4.d0a0cef8.png";